// extracted by mini-css-extract-plugin
export default {"container":"Transactions_container__PU9Q2","header":"Transactions_header__YGPoI","panel":"Transactions_panel__IJjzM","primary":"Transactions_primary__0BCLV"};